import { ImGoodAtState, IFlatExpertise } from './State'

import {
  SET_EXPERTISE_EDITING_INDEX,
  SET_EXPERTISE,
  SET_EXPERTISE_TITLE,
  ADD_NEW_EXPERTISE,
  REMOVE_EXPERTISE,
  SET_EXPERTISE_ERRORS,
  ADD_NEW_EXPERTISE_TAG,
  REMOVE_EXPERTISE_TAG,
  SET_EXPERTISE_TAG,
  SET_EXPERTISE_TAG_LEVEL,
  SET_STATE,
  SET_BECOME_EXPERT_IN,
  SET_BECOME_EXPERT_IN_EDITING_INDEX,
  ADD_NEW_BECOME_EXPERT_IN,
  REMOVE_BECOME_EXPERT_IN_ITEM,
  ImGoodAtAction,
  IUpdateIndexedItem
} from './Actions'

function removeKeyAndReIndex(object: { [key: string]: any }, key: string) {
  return Object.entries(object)
    .filter(([objectKey]) => objectKey !== key)
    .reduce(
      (acc, [, value], index) => ({
        ...acc,
        [index]: value
      }),
      {} as { [key: string]: any }
    )
}

function imGoodAtReducer(state: ImGoodAtState, action: ImGoodAtAction): ImGoodAtState {
  switch (action.type) {
    case SET_EXPERTISE_EDITING_INDEX:
      return {
        ...state,
        expertiseEditingIndex: action.payload as number
      }
    case SET_EXPERTISE:
      const { index: expIdx, value: expVal } = action.payload as IUpdateIndexedItem<IFlatExpertise>
      return {
        ...state,
        expertise: {
          ...state.expertise,
          [expIdx]: expVal
        }
      }
    case SET_EXPERTISE_TITLE:
      const { index: expTitleIdx, value: expTitleIdxVal } = action.payload as IUpdateIndexedItem<string>
      return {
        ...state,
        expertise: {
          ...state.expertise,
          [expTitleIdx]: {
            ...state.expertise[expTitleIdx],
            title: expTitleIdxVal
          }
        }
      }
    case ADD_NEW_EXPERTISE:
      const expertisesCount = Object.keys(state.expertise).length
      return {
        ...state,
        expertiseEditingIndex: expertisesCount,
        expertise: {
          ...state.expertise,
          [expertisesCount]: {
            title: '',
            tags: {
              0: {
                level: 0,
                title: ''
              }
            }
          }
        }
      }
    case REMOVE_EXPERTISE:
      const expertiseIndexToRemove = action.payload.toString()

      const newExpertise = removeKeyAndReIndex(state.expertise, expertiseIndexToRemove)

      return {
        ...state,
        expertiseEditingIndex: -1,
        expertise: newExpertise
      }
    case SET_EXPERTISE_ERRORS:
      return {
        ...state,
        expertiseErrors: {
          ...state.expertiseErrors,
          ...(action.payload as { [key: string]: boolean })
        }
      }

    case ADD_NEW_EXPERTISE_TAG:
      const expertiseIndex = action.payload.toString()
      const expertiseTagsCount = Object.keys(state.expertise[expertiseIndex].tags).length

      return {
        ...state,
        expertise: {
          ...state.expertise,
          [expertiseIndex]: {
            ...state.expertise[expertiseIndex],
            tags: {
              ...state.expertise[expertiseIndex].tags,
              [expertiseTagsCount]: {
                value: '',
                level: 0
              }
            }
          }
        }
      }
    case REMOVE_EXPERTISE_TAG:
      const { expertiseIndex: expIdxTagToRm, tagIndex } = action.payload as { expertiseIndex: number; tagIndex: number }

      return {
        ...state,
        expertise: {
          ...state.expertise,
          [expIdxTagToRm]: {
            ...state.expertise[expIdxTagToRm],
            tags: removeKeyAndReIndex(state.expertise[expIdxTagToRm].tags, tagIndex.toString())
          }
        }
      }
    case SET_EXPERTISE_TAG:
      const { expertiseIndex: setExpTagValueIdx, tagIndex: setTagIdx, value: setTagValue } = action.payload as {
        expertiseIndex: number
        tagIndex: number
        value: string
      }

      return {
        ...state,
        expertise: {
          ...state.expertise,
          [setExpTagValueIdx]: {
            ...state.expertise[setExpTagValueIdx],
            tags: {
              ...state.expertise[setExpTagValueIdx].tags,
              [setTagIdx]: {
                ...state.expertise[setExpTagValueIdx].tags[setTagIdx],
                title: setTagValue
              }
            }
          }
        }
      }
    case SET_EXPERTISE_TAG_LEVEL:
      const { expertiseIndex: setExpTagLevelIdx, tagIndex: setTagLevelIdx, value: level } = action.payload as {
        expertiseIndex: number
        tagIndex: number
        value: number
      }

      return {
        ...state,
        expertise: {
          ...state.expertise,
          [setExpTagLevelIdx]: {
            ...state.expertise[setExpTagLevelIdx],
            tags: {
              ...state.expertise[setExpTagLevelIdx].tags,
              [setTagLevelIdx]: {
                ...state.expertise[setExpTagLevelIdx].tags[setTagLevelIdx],
                level
              }
            }
          }
        }
      }
    case SET_STATE:
      return action.payload as ImGoodAtState

    case SET_BECOME_EXPERT_IN:
      const { index, value } = action.payload as IUpdateIndexedItem<string>
      return {
        ...state,
        becomeExpertIn: {
          ...state.becomeExpertIn,
          [index]: value
        }
      }
    case SET_BECOME_EXPERT_IN_EDITING_INDEX:
      return {
        ...state,
        becomeExpertInEditingIndex: action.payload as number
      }
    case ADD_NEW_BECOME_EXPERT_IN:
      const nextBecomeExpertInIndex = Object.keys(state.becomeExpertIn).length
      return {
        ...state,
        becomeExpertIn: {
          ...state.becomeExpertIn,
          [nextBecomeExpertInIndex]: ''
        },
        becomeExpertInEditingIndex: nextBecomeExpertInIndex
      }
    case REMOVE_BECOME_EXPERT_IN_ITEM:
      const becomeExpertInItemIndexToRemove = action.payload.toString()

      return {
        ...state,
        becomeExpertIn: removeKeyAndReIndex(state.becomeExpertIn, becomeExpertInItemIndexToRemove),
        expertiseEditingIndex: -1
      }
    default:
      return state
  }
}

export default imGoodAtReducer
